<app-navbar></app-navbar>
<app-presence-indicator></app-presence-indicator>
<router-outlet></router-outlet>
